
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter, Action, Mutation } from "vuex-class";
import Loader from "@/components/App/Loader.vue";
import ContactCard from "@/components/ContactCard.vue";
import appConstants from "@/appConstants";

@Component({
  components: {
    Loader,
    ContactCard
  }
})
export default class MemberContact extends Vue {
  @Getter("memberCompanyInfo") memberCompanyInfo: any;
  @Getter("memberContact") memberContact: any;
  @Action("getUserCompanyInfo") getUserCompanyInfo: any;
  @Action("setError") setError: any;

  loading = true;
  created() {
    this.getUserCompanyInfo().then((response: any) => {
      this.loading = false;
    });
  }
}
